import React from 'react'
import { IoIosCloseCircleOutline } from 'react-icons/io'

const ProcessorDetailsModal = ({
  setShowDetailsModal,
  selected = {},
  onDelete,
  loading,
}) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[99999] backdrop-blur-md">
      <div className="bg-white dark:bg-dark rounded-lg shadow-lg w-full md:max-w-3xl relative max-h-[90vh] flex flex-col">
        <div className='flex flex-row justify-between items-center border-b border-gray-200 p-4 flex-shrink-0 dark:border-border-dark'>
          <h2 className='text-xl font-bold dark:text-white'>
            View Processor Details
          </h2>
          <button
            onClick={() => setShowDetailsModal(false)}
            className="absolute top-4 right-4 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
          >
            <IoIosCloseCircleOutline className="h-5 w-5" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4">
          <h2 className="text-base font-medium text-yellowcolor mb-4">
            Processor Information
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
            {/* Profile Image */}
            <div className="flex flex-col items-center md:items-start">
              <span className="text-sm font-medium text-gray-700 mb-2 dark:text-white">Profile Image</span>
              {selected?.profile_img ? (
                <img src={selected?.profile_img} alt="Profile" className="w-32 h-32 rounded-full object-cover shadow" />
              ) : (
                  <div className="w-32 h-32 rounded-full bg-gray-100 flex items-center justify-center dark:bg-dark border dark:border-border-dark dark:text-white">
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="8" r="4" stroke="#D1D5DB" strokeWidth="2" /><path d="M4 20c0-2.21 3.582-4 8-4s8 1.79 8 4" stroke="#D1D5DB" strokeWidth="2" /></svg>
                </div>
              )}
            </div>
            {/* Details */}
            <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2">
              <div>
                <div className="text-sm text-gray-400 font-medium">First Name</div>
                <div className="font-normal capitalize text-black mb-2 dark:text-white">
                  {selected?.processor?.is_business_account ? selected?.processor?.business_name : selected?.processor?.farm_name || "N/A"}
                </div>
              </div>
              <div>
                <div className="text-sm text-gray-400 font-medium">Last name</div>
                <div className="font-normal capitalize text-black mb-2 dark:text-white">{selected?.processor?.lastname || '-'}</div>
              </div>
              <div>
                <div className="text-sm text-gray-400 font-medium">Email</div>
                <div className="font-normal text-black mb-2 dark:text-white">{selected?.processor?.email || '-'}</div>
              </div>
              <div>
                <div className="text-sm text-gray-400 font-medium">Phone Number</div>
                <div className="font-normal capitalize text-black mb-2 dark:text-white">{selected?.processor?.phone || '-'}</div>
              </div>
              <div>
                <div className="text-sm text-gray-400 font-medium">Factory Name</div>
                <div className="font-normal capitalize text-black mb-2 dark:text-white">{selected?.processor?.farm_name || '-'}</div>
              </div>
              <div>
                <div className="text-sm text-gray-400 font-medium">Region</div>
                <div className="font-normal capitalize text-black mb-2 dark:text-white">{selected?.processor?.region || '-'}</div>
              </div>
              <div>
                <div className="text-sm text-gray-400 font-medium">District</div>
                <div className="font-normal capitalize text-black mb-2 dark:text-white">{selected?.processor?.district || '-'}</div>
              </div>
              <div>
                <div className="text-sm text-gray-400 font-medium">Community</div>
                <div className="font-normal capitalize text-black mb-2 dark:text-white">{selected?.processor?.community || '-'}</div>
              </div>
              <div>
                <div className="text-sm text-gray-400 font-medium">Gender</div>
                <div className="font-normal capitalize text-black mb-2 dark:text-white">{selected?.processor?.gender || '-'}</div>
              </div>
              <div>
                <div className="text-sm text-gray-400 font-medium">Factory Size</div>
                <div className="font-normal capitalize text-black mb-2 dark:text-white">{selected?.processor?.factory_size?.replace(/_/g, ' ') || 'N/A'}</div>
              </div>
              <div>
                <div className="text-sm text-gray-400 font-medium">Source of  Raw Materials</div>
                <div className="capitalize font-normal text-black mb-2 dark:text-white"
                >
                  {selected?.processor?.materials_source?.join(', ')?.replace(/_/g, ' ')}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='border-t p-4 z-50 border-gray-200 flex flex-row items-end justify-end w-full bg-white dark:bg-dark flex-shrink-0 dark:border-border-dark'>
          <div className="flex flex-row items-end justify-end gap-4">
            <button
              onClick={() => setShowDetailsModal(false)}
              className='px-6 text-sm py-2 bg-white dark:bg-dark border dark:border-border-dark dark:text-white text-black rounded-lg'>
              Close
            </button>

            {/* Deactivate / Reactivate */}
            <button className="px-6 py-2 rounded-lg bg-yellowcolor hover:bg-yellowcolor/80 text-black" onClick={onDelete}>
              {loading ? "Please wait..." : "Delete"}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProcessorDetailsModal